<template>
  <div >
    <v-row>
    
  <v-col cols="7" class="mt-4 ml-6" style="background-color: white;min-height: 800px;">

   <v-card elevation="0" class="pt-4">
    <v-row class="px-4" >
        <v-col cols="12" >

        
          <h1>FalksteinTabelle | 2025</h1>
          <h3>Die leistungsstärksten Brillenversicherungen </h3>
   
         <ul>
          <li>Die leistungsstärksten Brillenversicherungen 2025 auf einen Blick</li>
          <li>Preiswerte Brillenversicherungen ohne Wartezeit im Vergleich</li>
          <li>Brillenversicherungen für Kinder - Unsere Testsieger 2025</li>
         </ul>
         <br>

        </v-col>
       
      </v-row>
      <v-table style="border-right: 4px solid #ff9800;">
      <br />
      <thead>
        <tr style="background-color: #f0f0f0;">
          <th style="max-width: 10px">#</th>
          <th>Tarif</th>
          <th>Ø-Erstattung</th>
          <th>Begrenzung</th>
          <th>Preis 55 Jahre</th>
        </tr>
      </thead>
      <tbody>
        <tr
          @click="berechnungStore.setShowPopAppTarif(tarif, 'showTarifOptions')"
          style="vertical-align: top; cursor: pointer"
          v-for="tarif in tarife"
          :key="tarif.id"
        >
          <td>{{ tarif.rank }}.</td>
          <td>
            <strong
              ><router-link
                :to="'/testbericht/' + tarif.tarif_key"
                >{{ tarif.versicherung }}</router-link
              >
            </strong>

            <br />
            {{ tarif.tarif_title }}
          </td>
          <td>{{ tarif.waizmannwert }} %</td>
          <td>{{ tarif.begrenzung }}</td>
          <td>{{ tarif.preis_value }} €</td>
        </tr>
      </tbody>
    </v-table>
   </v-card>


  

  </v-col>
  <v-col cols="4">
        <v-card class="mx-auto" max-width="500" border flat>
    

    <v-card-text class="text-medium-emphasis pa-6">
      <div class="text-h6 mb-6">Jetzt Brillenversicherung vergleichen</div>

   
      <v-row>
     
        <v-col cols="12">
         <v-btn color="#ff9800" href="/vergleich" block height="56px" class="nocaps text-white" style="font-size: 20px;">FalksteinVergleich starten</v-btn>
        </v-col>
      </v-row>


    </v-card-text>
  </v-card>

    <v-row>
      <v-col v-for="(empfehlung, index) in empfehlungen" :key="index" cols="12" >
        <v-card class="mx-auto my-3 recommendation-card" elevation="1">
          <v-card-item>
            <div class="d-flex align-center">
              <v-avatar class="mr-4" size="60" color="#ff9800">
                <v-icon size="36" color="white">mdi-glasses</v-icon>
              </v-avatar>
              <div>
                <v-card-title>{{ empfehlung.name }}</v-card-title>
                <v-card-subtitle>{{ empfehlung.position }}</v-card-subtitle>
              </div>
            </div>
          </v-card-item>
          <v-card-text>
            <p class="recommendation-text">
              {{ showFullText[index] ? empfehlung.text : empfehlung.text.split(' ').slice(0, 10).join(' ') + '...' }}
            </p>
            <a 
      href="#" 
      class="text-decoration-none text-primary ml-1"
      @click.prevent="toggleText(index)"
    >
      {{ showFullText[index] ? 'weniger anzeigen' : 'mehr lesen' }}
    </a>
          </v-card-text>
        
        </v-card>
      </v-col>
    </v-row>
  </v-col>
  </v-row>
  <v-row>
      <v-col cols="12">

        <masonry-wall :items="fragen" :ssr-columns="1" :column-width="260" :gap="16" class="my-12">
    <template #default="{ item }">
      <v-card :style="{ height: `${item.height}px` }" elevation="1" class="mr-4 mb-4">
        <v-row style="font-size: 16px;">
          <v-col cols="2">
            <v-avatar class="mr-3">
              <v-icon>mdi-chat-question</v-icon>
            </v-avatar>
          </v-col>
          <v-col cols="10">
            <b>{{ item.content_keywords }}</b>
          </v-col>
        </v-row>
        <v-card-text  class="pa-2">{{ item.content_title }}
          <a :href="'/antwort/' + item.content_speaking_link">Antwort lesen</a>
          <!-- <br><b style="font-size: 12px;">{{item.name}}</b> -->
        </v-card-text>
      </v-card>
    </template>
  </masonry-wall>
  </v-col>
  </v-row>
  <v-row>
    <v-col cols="6"><h2>Was genau ist eine Brillenversicherung?</h2>
        <p>
          Eine Brillenversicherung ist eine spezielle Versicherung, die die Kosten für Sehhilfen wie Brillen und Kontaktlinsen übernimmt. Aber auch regelmäßige Augenvorsorgeuntersuchungen, Augenlaserbehandlungen und Hörgeräte sind in einer leistungsstarken Brillenversicherung enthalten. Sie bietet finanzielle Unterstützung beim Kauf neuer Brillen und Kontaktlinsen, bei der Reparatur und auch beim Verlust oder Diebstahl. Eine Brillenversicherung unterstützt dich dabei, deine Sehfähigkeit bis ins hohe Alter zu erhalten.
        </p>
<br><br>
        <h2>Warum ist eine Brillenversicherung sinnvoll?</h2>
        <p>Eine Brillenversicherung lohnt sich aus mehreren Gründen:</p>
        <ul>
          <li>
            <strong>Kostenersparnis:</strong> Hochwertige Brillen und Kontaktlinsen können teuer sein. Eine Brillenversicherung hilft dir, diese Kosten zu tragen.
          </li>
          <li>
            <strong>Regelmäßige Anpassung der Sehstärke:</strong> Mit einer Brillenversicherung kannst du deine Sehhilfen regelmäßig erneuern und an deine aktuelle Sehstärke anpassen lassen. Das steigert deine Lebensqualität und kostet dich nichts.
          </li>
          <li>
            <strong>Regelmäßige Vorsorge:</strong> Eine Brillenversicherung deckt regelmäßige Augenvorsorgeuntersuchungen ab, um mögliche Erkrankungen frühzeitig zu erkennen und behandeln zu lassen. So kannst du deine Sehfähigkeit bis ins hohe Alter erhalten.
          </li>
          <li>
            <strong>Reparatur und Verlust:</strong> Eine Brillenversicherung übernimmt auch die Kosten für die Reparatur deiner Brille oder wenn deine Brille verloren geht.
          </li>
        </ul>
        <p>
          <strong>Fazit:</strong> Eine Brillenversicherung entlastet dich finanziell und hilft dir, deine Augengesundheit langfristig und bis ins hohe Alter zu bewahren.
        </p>
        <p>
          <router-link to="/vergleich">Finde jetzt die richtige Brillenversicherung für dich - Jetzt Brillenversicherung vergleichen</router-link>
        </p>
        <br><br>
        <h2>Welche Kosten sollte eine leistungsstarke Brillenversicherung übernehmen?</h2>
        <p>
          Eine gute und leistungsstarke Brillenversicherung deckt die folgenden Leistungsbereiche ab:
        </p>
        <br><br>
        <h3>1. Kosten für Sehhilfen</h3>
        <p>
          Eine leistungsstarke Brillenversicherung leistet für die unterschiedlichen Arten von Sehhilfen. Dazu gehören:
        </p>
        <ul>
          <li>Einstärkenbrillen</li>
          <li>Gleitsichtbrillen</li>
          <li>Bifokalbrillen</li>
          <li>Bifokal- und Trifokalbrillen</li>
          <li>Computerbrillen</li>
          <li>Arbeitsbrillen</li>
          <li>Sportbrillen</li>
          <li>Sonnenbrillen mit Stärke</li>
          <li>Prismenbrillen</li>
        </ul>
        <br><br>
        <h3>2. Kosten für Augenvorsorgeuntersuchungen</h3>
        <p>
          Regelmäßige Vorsorge-Untersuchungen sind entscheidend, um Augenerkrankungen frühzeitig zu erkennen und behandeln zu lassen. Deshalb sollte eine leistungsstarke Brillenversicherung nicht nur Leistungen für Sehhilfen, sondern auch für regelmäßige Augenvorsorgeuntersuchungen wie zum Beispiel Glaukomvorsorge (Schutz vor grünem Star) enthalten.
        </p>
        <br><br>
        <h3>3. Kosten für Augenlaserbehandlungen (LASIK)</h3>
        <p>
          Eine leistungsstarke und moderne Brillenversicherung sollte zusätzlich auch die Kosten für Augenlaseroperationen wie zum Beispiel LASIK abdecken, falls du dich für eine dauerhafte Korrektur deiner Sehstärke entscheidest.
        </p>
        <br><br>
        <h3>4. Kosten für Hörgeräte</h3>
        <p>
          Da im Alter nicht nur die Sehfähigkeit, sondern auch das Hörvermögen nachlassen kann, ist es sinnvoll, wenn die Versicherung auch Leistungen für Hörgeräte umfasst.
        </p>
        <br><br>
        <h3>5. Kosten für weitere Zusatzleistungen</h3>
        <p>
          Besonders leistungsstarke Tarife umfassen oft auch zusätzliche Leistungen, wie etwa die Kostenübernahme für weitere Hilfsmittel (wie z.B. Perücken, Schlafapnoegeräte (CPAP), Insulinpumpen, Krankenfahrstühle, etc.), zusätzliche Vorsorgeuntersuchungen (wie z.B. Hautkrebs-Vorsorge) oder Schutzimpfungen (wie z.B. Reiseschutzimpfungen).
        </p>
        <br><br>
        <h2>Wartezeiten und Leistungsbegrenzungen</h2>
        <p>
          Darauf solltest du bei deiner Brillenversicherung achten.
        </p>
        <br><br>
        <h3>1. Wartezeit: Leistet meine Brillenversicherung sofort für die neue Brille?</h3>
        <p>
          Ein wichtiger Punkt bei der Wahl einer Brillenversicherung ist die Wartezeit. Einige Versicherungen setzen eine Wartezeit voraus, bevor Leistungen in Anspruch genommen werden können. Dies gilt sowohl für allgemeine Leistungen als auch für spezielle Leistungen wie Augenlaserbehandlungen (z.B. LASIK).
        </p>
        <p>
          <strong>Sofort-Tarife:</strong> Einige Tarife bieten direkte Leistungen ab Versicherungsbeginn und übernehmen damit sofort die Kosten für die neue Brille.
        </p>
        <p>
          <router-link to="/vergleich">Jetzt die leistungsstärksten Brillenversicherungen vergleichen</router-link>
        </p>
        <br><br>
        <h3>2. Leistungsbegrenzungen: Wie viel Euro zahlt meine Brillenversicherung für die neue Brille?</h3>
        <p>
          Die Leistungsbegrenzungen einer Brillenversicherung bestimmen, welchen maximalen Betrag die Versicherung innerhalb eines festgelegten Zeitraums erstattet.
        </p>
        <br><br>
        <h4>3 Arten von Leistungsbegrenzungen bei Brillenversicherungen:</h4>
        <ul>
          <li>
            <strong>Anfängliche Leistungsbegrenzungen:</strong> Einzelne Brillenversicherungen beschränken in den ersten Versicherungsjahren (meistens 2 Jahre) die maximale Erstattung für alle Leistungen. So werden beispielsweise in den ersten beiden Jahren nur max. 200€ für alle Leistungen übernommen. Danach entfallen diese anfänglichen Begrenzungen.
          </li>
          <li>
            <strong>Maximalbetrag für Sehhilfen:</strong> Viele Brillen-Tarife begrenzen die Erstattung für Sehhilfen auf 100€ bis 500€, meist innerhalb eines Zeitraums von zwei Jahren. Achte darauf, dass der Betrag möglichst deinen Anschaffungskosten für Brillen oder Kontaktlinsen abdeckt.
          </li>
          <li>
            <strong>Spezielle Leistungsbegrenzungen:</strong> Für bestimmte Leistungen, wie Augenlaserbehandlungen, gelten oft zusätzliche Einschränkungen. So wird beispielsweise max. 700€ für die Laserbehandlung eines Auges erstattet – und das nur einmal während der gesamten Vertragslaufzeit.
          </li>
        </ul>
        <br><br>
      </v-col>
    <v-col cols="6">
     
        <h2>Wie viel kostet eine Brillenversicherung durchschnittlich im Monat?</h2>
        <p>
          Die Kosten für eine Brillenversicherung hängen vom Leistungsumfang ab.
        </p>
        <ul>
          <li>
            <strong>Basis-Tarife:</strong> Kosten zwischen 5–10€ pro Monat und decken einfache Brillen oder Kontaktlinsen ab.
          </li>
          <li>
            <strong>Premium-Tarife:</strong> Kosten zwischen 15–30€ pro Monat und beinhalten zusätzliche Leistungen wie Augenlaseroperationen, Hörgeräte oder Vorsorgeuntersuchungen.
          </li>
        </ul>
        <p>
          <router-link to="/vergleich">Vergleiche jetzt die leistungsstärksten Brillen-Tarife und finde deinen Preis-Leistungs-Testsieger</router-link>
        </p>
        <br><br>
        <h2>Warum ist eine Brillenversicherung für Kinder wichtig?</h2>
        <p>
          Die gesetzliche Krankenversicherung (GKV) übernimmt nur einen Teil der Kosten für Kinderbrillen und deckt hochwertige Gestelle oder Prismenbrillen gar nicht ab.
        </p>
        <p>
          <strong>Hinweis:</strong> Die Festzuschüsse der GKV für Kinderbrillen variieren je nach Alter des Kindes und der Glasstärke und liegen zwischen 10€ und 112€ pro Brillenglas.
        </p>
        <p>
          Eine private Brillenversicherung für Kinder schließt diese Lücke und bietet:
        </p>
        <ul>
          <li>Volle Kostenübernahme für teurere Brillengestelle</li>
          <li>Abdeckung für Spezialbrillen wie Prismenbrillen</li>
        </ul>
        <p>
          <strong>Was kostet eine Brillenversicherung für Kinder?</strong><br />
          Der durchschnittliche Beitrag liegt zwischen 8€ und 20€ pro Monat. Angesichts der steigenden Sehprobleme durch die vermehrte Bildschirmzeit ist eine Brillenversicherung für Kinder heute relevanter denn je.
        </p>
        <p>
          <router-link to="/vergleich">FalksteinTabelle Kinder - Jetzt vergleichen und die optimale Brillenversicherung für dein Kind finden</router-link>
        </p>
<br><br>
        <h2>LASIK-Versicherungen | Der Schutz bei Augenlaser-Operationen</h2>
        <p>
          Für viele Menschen ist LASIK oder eine ähnliche Augenlaser-Operation der Schritt zu einem brillenfreien Leben. Doch mit Kosten zwischen 900€ und 2000€ pro Auge stellt diese Behandlung eine erhebliche finanzielle Belastung dar, die von der gesetzlichen Krankenversicherung (GKV) in der Regel nicht übernommen wird.
        </p>
        <p>
          Hier kommen Brillenversicherungen ins Spiel, die auch für LASIK leisten: Sie erstatten bis zu 1500€ der Kosten und ermöglichen so den Zugang zu moderner Technologie und sicheren Verfahren. Mit einer LASIK-Versicherung kannst du langfristig Kosten sparen und Lebensqualität gewinnen.
        </p>
        <p>
          <router-link to="/vergleich">Jetzt LASIK-Versicherungen vergleichen</router-link>
        </p>
<br><br>
        <h2>Klare Sicht am Bildschirm - Versicherungen für Arbeitsplatzbrillen</h2>
        <p>
          Arbeitest du viel am Bildschirm? Eine Arbeitsplatzbrille schützt deine Augen und steigert dein Wohlbefinden.
        </p>
        <h3>Warum ist eine Arbeitsplatzbrille sinnvoll?</h3>
        <p>
          Bildschirmarbeit kann zu Augenbelastung und Kopfschmerzen führen. Eine Arbeitsplatzbrille, speziell für deinen Sehbereich am Monitor optimiert, bietet die Lösung. Die Kosten liegen zwischen 200€ und 400€, die die gesetzliche Krankenversicherung (GKV) nicht übernimmt.
        </p>
        <br><br>
        <h3>Vorteile einer Brillenversicherung für die Arbeitsplatzbrille</h3>
        <p>
          Mit einer Brillenversicherung kannst du die Kosten unabhängig vom Arbeitgeber finanzieren. Finde mit der FalksteinTabelle die ideale Versicherung, die auch für deine Arbeitsplatzbrille leistet.
        </p>
        <p>
          <router-link to="/vergleich">Arbeitsplatzbrille - Jetzt die leistungsstärksten Brillenversicherungen vergleichen</router-link>
        </p>
        <br><br>
        <h2>Falkstein-Realwert-Methode - Der neue Bewertungsstandard für Brillenversicherungen</h2>
        <h3>Was ist der Falkstein-Realwert?</h3>
        <p>
          Der Falkstein-Realwert ist ein objektiv berechneter Vergleichswert, der die Leistungsstärke von Brillenversicherungen in % angibt und damit die unterschiedlichen Brillenversicherungen am Markt vergleichbar macht.
        </p>
        <br><br>
        <h3>Wie wird der Falkstein-Realwert berechnet?</h3>
        <p>
          Anhand eines klar definierten Warenkorbs von Sehhilfe-Leistungen, der sich über 4 Jahre erstreckt, wird die Leistungsstärke eines Tarifs objektiv in Prozent berechnet.
        </p>
        <p>
          Der Warenkorb beinhaltet sowohl Leistungen für Sehhilfen, einschließlich Gleitsichtbrillen, Sonnenbrillen und Kontaktlinsen, sowie Leistungen für Augenlaser-Behandlungen (LASIK) und Augenvorsorgeuntersuchungen.
        </p>
        <p>
          Auch Leistungsbegrenzungen und versteckte Leistungseinschränkungen werden einbezogen, um am Ende eine objektive, verlässliche und aussagekräftige Leistungskennziffer zu erhalten.
        </p>
        <p>
          <router-link to="/vergleich">Vergleiche jetzt die leistungsstärksten Brillenversicherungen</router-link>
        </p>
<br><br>
        <h2>Brillenversicherungen von Apollo, Fielmann und Co.</h2>
        <p>
          Optikerketten wie Apollo oder Fielmann werben oft mit eigenen Brillenversicherungen. Diese wirken auf den ersten Blick attraktiv und kostengünstig. Doch bei genauerem Hinsehen zeigen sich oft erhebliche Einschränkungen, wie zum Beispiel begrenzte Leistungen, hohe Selbstbeteiligungen und eine Bindung an das Sortiment der jeweiligen Optikerkette.
        </p>
        <p>
          Unabhängige Brillenversicherungen bieten hier mehr Flexibilität, da die Leistung nicht an bestimmte Optiker oder Marken gebunden ist.
        </p>
        <p>
          Vergleiche deshalb die Angebote von Apollo, Fielmann und anderen Optikerketten sorgfältig mit unabhängigen Brillenversicherungen und entscheide dich im Zweifelsfall für mehr Flexibilität beim Brillenkauf!
        </p>
        <p>
          <router-link to="/vergleich">Vergleiche jetzt die leistungsstärksten Brillenversicherungen</router-link>
        </p>
    </v-col>
  </v-row>
      
        
       
  
  
  </div>
</template>


<script setup>
  import { getCurrentInstance, onMounted, ref } from "vue";
  import { useBerechnungStore } from "@/stores/berechnung";
  import BaseCalls from "@/services/BaseCalls";

import MasonryWall from '@yeger/vue-masonry-wall'

  const berechnungStore = useBerechnungStore();

  const tableTyp = ref('brilleAlle');

  const tarife = ref(false);
  const fragen = ref([]);

  async function getContent() {
    let berSelect = {};
    berSelect.action = "getContent";
   
    try {
      const resp = await BaseCalls.postMixedNew(berSelect); // Korrigiert, um .value zu verwenden
      if (resp.data && resp.data.content) {
        console.log(resp.data.content);
        fragen.value = resp.data.content;
      }
    } catch (err) {
      console.log("error frage ");
    }
  }

 // ... existing code ...
const empfehlungen = ref([
  {
    name: "Thomas M.",
    position: "Optiker in Hamburg",
    text: "Die FalksteinTabelle hat unsere Beratungsgespräche revolutioniert. Unsere Kunden schätzen die transparente Übersicht der Versicherungsoptionen und wir sparen wertvolle Zeit. Ein unverzichtbares Werkzeug für jeden modernen Optikerbetrieb."
  },
  {
    name: "Sabine W.",
    position: "Optikerin in Berlin",
    text: "Endlich eine übersichtliche Vergleichstabelle für Brillenversicherungen! Mit der FalksteinTabelle können wir unseren Kunden auf einen Blick die optimale Versicherungslösung präsentieren. Das schafft Vertrauen und erhöht unsere Abschlussquote erheblich."
  },
  {
    name: "Dr. Andreas S.",
    position: "Optiker in Frankfurt",
    text: "Als Optiker mit über 20 Jahren Erfahrung kann ich die FalksteinTabelle nur wärmstens empfehlen. Sie vereinfacht den komplexen Vergleich von Versicherungsangeboten und hilft uns, maßgeschneiderte Lösungen für jeden Kunden zu finden."
  },
  {
    name: "Maria B.",
    position: "Optikerin in Köln",
    text: "Die FalksteinTabelle ist ein Gamechanger in der Kundenberatung. Die übersichtliche Darstellung aller Versicherungsdetails spart nicht nur Zeit, sondern erhöht auch die Kundenzufriedenheit spürbar. Ein unverzichtbares Tool für unseren Alltag."
  }
]);
// ... existing code ...

  // Function to calculate height based on description length
  function calculateHeight(description) {
    const charsPerLine = 50; // Estimated characters per line
    const lineHeight = 20;    // Line height in pixels
    const baseHeight = 100;    // Base height to accommodate title and padding
    const numLines = Math.ceil(description.length / charsPerLine);
    return baseHeight + (numLines * lineHeight) * 1.9;
  }

  // Calculate height for each item
  fragen.value.forEach(frage => {
    frage.height = calculateHeight(frage.description);
  });

  async function getTarife() {
    let select = {};

    console.log("getTarife " + tableTyp.value);
    select.action = "getStaticBrilleTarife";
    select.select = tableTyp.value;
    select.addPreis = 19;

    try {
      const resp = await BaseCalls.postTarif(select);
      if (resp.data && resp.data.tarife) {
        tarife.value = resp.data.tarife;        
      }
    } catch (err) {
      console.log("error berechnung");
    }
  }

  onMounted(() => {
    getTarife();
    berechnungStore.setShowFooter(true);
    const { proxy } = getCurrentInstance();
    getContent();
    proxy.$updateDocumentHead(
      "FalksteinTabelle - Die besten Brillenversicherungen 2025 im Vergleich",
      "Jetzt die leistungsstärksten Brillenversicherungen 2025 vergleichen - Preiswerte Tarife ohne Wartezeit, mit Leistungen für Sehhilfen, LASIK und Hörgeräte"
    );
  });

  // Array to track which testimonials are expanded
  const showFullText = ref(empfehlungen.value.map(() => false));

  // Function to toggle between abbreviated and full text
  const toggleText = (index) => {
    showFullText.value[index] = !showFullText.value[index];
  };
</script>
